class SharedFunctions {
  uuid () {
    const chars = '0123456789abcef'.split('')
    let uuid = []
    let rnd = Math.random
    let r
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-'
    uuid[14] = '4' // version 4
    for (let i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | rnd() * 16
        uuid[i] = chars[(i === 19) ? (r & 0x3) | 0x8 : r & 0xf]
      }
    }
    return uuid.join('')
  }

  static isInLandscapeMode () {
    let orientationAngle = 0
    if (typeof window.orientation === 'number') {
      // iOS
      orientationAngle = window.orientation
    } else {
      // Android
      orientationAngle = screen?.orientation?.angle || 0
    }
    return orientationAngle === 90 || orientationAngle === 270 || orientationAngle === -90
  }
}

export { SharedFunctions }
